/** Page buttons and the "x–y von z" label for paged lists (#14). */

import { CANDIDATE_NOUN, formatCount, nounFor, type Noun } from "./formatters/count";

export type PageItem = number | "gap";

/** The pages to offer: the first, the last and the current one with its
 * neighbours, with a gap for every run of skipped pages. A single skipped
 * page is shown instead of a gap, since the gap would take the same room. */
export function pageNumbers(current: number, total: number): PageItem[] {
  const keep = [1, current - 1, current, current + 1, total]
    .filter((p) => p >= 1 && p <= total)
    .sort((a, b) => a - b)
    .filter((p, i, all) => i === 0 || p !== all[i - 1]);
  const items: PageItem[] = [];
  for (const p of keep) {
    const prev = items.length ? (items[items.length - 1] as number) : 0;
    if (prev && p - prev === 2) items.push(prev + 1);
    else if (prev && p - prev > 2) items.push("gap");
    items.push(p);
  }
  return items;
}

export function pageRangeLabel(
  page: number,
  pageSize: number,
  count: number,
  nouns: Noun = CANDIDATE_NOUN,
): string {
  if (count === 0) return `Keine ${nouns.many}`;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, count);
  const noun = nounFor(count, nouns);
  const of = `von ${formatCount(count)} ${noun}`;
  return from === to
    ? `${formatCount(from)} ${of}`
    : `${formatCount(from)}–${formatCount(to)} ${of}`;
}
